import createReducer from './baseReducer';

export default createReducer('vehicleTypes', 'vehicle_type', 'vehicle_types');
